var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import moment from "moment";
import { container } from "../../inversify/inversify.config";
import { TYPES } from "../../inversify/types";
import { Container } from "../../common/Container";
import { ExtensionClientLedgerFilter } from "./TransactionHistoryFilter";
import { getYesterdaysDate } from "../../common/Validation";
import { ClientLedgerParams } from "../../helpers/Domain/ViewModels/Reports/ClientLedgerParams";
import { StringResource } from "../../helpers/Domain/Common/StringResource";
import { generate_BillNo_Format } from "../../common/helper";
import { ReturnDeliveryModes } from "../../common/helper";
import { PagingState, CustomPaging, DataTypeProvider, SearchState, SortingState, } from "@devexpress/dx-react-grid";
import { Grid, Table, TableHeaderRow, PagingPanel, SearchPanel, Toolbar, } from "@devexpress/dx-react-grid-material-ui";
import { getAdhocCompanies, getClientLedger } from "../../services/Apis";
var columns = [
    { name: "Date", title: "Date" },
    { name: "Description", title: "Description" },
    { name: "Increase", title: "Increase" },
    { name: "Decrease", title: "Decrease" },
    { name: "Balance", title: "Balance" },
    { name: "AdjustmentDate", title: "Adjustment Date" },
];
var excelUtilities = container.get(TYPES.IExcelUtilities);
var ExtensionClientLedger = /** @class */ (function (_super) {
    __extends(ExtensionClientLedger, _super);
    function ExtensionClientLedger(props) {
        var _this = _super.call(this, props) || this;
        _this.getDeliveryMode = function () {
            return ReturnDeliveryModes.ElectronicFiled;
        };
        _this.getClientLedgerData = function (clientLedgerParams) {
            var _self = _this;
            _self.setState({ currentPage: 0 });
            if (clientLedgerParams.CompanyId != 0) {
                var fromDate = moment(clientLedgerParams.FromDate).format("MM/DD/YYYY");
                var toDate = moment(clientLedgerParams.ToDate).format("MM/DD/YYYY");
                var queryString = "?FromDate=".concat(fromDate, "\n                           &ToDate=").concat(toDate, "\n                           &CompanyId=").concat(clientLedgerParams.CompanyId, "\n                           &DeliveryMode=").concat(clientLedgerParams.DeliveryMode);
                getClientLedger(queryString).then(function (response) {
                    var currentBalance = response.data.length > 0 ? response.data[0].TotalBalance : 0;
                    var filteredData = response.data.filter(function (value) {
                        if (value.Description != "") {
                            if (value.Remarks) {
                                value.Description = value.Description + " - " + value.Remarks;
                            }
                            if (!value.AdjustmentDate) {
                                value.AdjustmentDate = "";
                            }
                            return value;
                        }
                    });
                    _self.setState({
                        rows: filteredData,
                        totalCount: response.data.length,
                        searchRows: filteredData,
                        currentBalance: currentBalance,
                        currentPage: 0,
                        sorting: [{ columnName: "Date", direction: "desc" }],
                    }, _self.GetClientSideFilteredData);
                });
            }
        };
        _this.prepareCompanyData = function (companyData) {
            var data = __spreadArray([], __read(companyData), false);
            var filteredData = [];
            var clonedData = JSON.parse(JSON.stringify(data));
            filteredData = clonedData.filter(function (item, i, arr) {
                if (item.IsTestCompany) {
                    item.CompanyName = item.CompanyName + " (Test)";
                }
                if (arr.findIndex(function (o) { return o.CompanyId === item.CompanyId; }) === i) {
                    return item;
                }
            });
            return filteredData;
        };
        _this.search = function (value) {
            _this.setState({
                searchRows: _this.state.rows,
                searching: value,
                currentPage: 0,
            }, _this.GetClientSideFilteredData);
        };
        _this.changeCurrentPage = function (currentPage) {
            _this.setState({
                currentPage: currentPage,
            }, _this.GetClientSideFilteredData);
        };
        _this.GetClientSideFilteredData = function () {
            var tempData = __spreadArray([], __read(_this.state.searchRows), false);
            tempData = tempData.filter(function (x) {
                return moment(x.Date)
                    .format("MM/DD/YYYY")
                    .includes(_this.state.searching.toLocaleLowerCase()) ||
                    x.Description.toString()
                        .toLocaleLowerCase()
                        .includes(_this.state.searching.toLocaleLowerCase()) ||
                    x.Increase.toString()
                        .toLocaleLowerCase()
                        .includes(_this.state.searching.toLocaleLowerCase()) ||
                    x.Decrease.toString()
                        .toLocaleLowerCase()
                        .includes(_this.state.searching.toLocaleLowerCase()) ||
                    x.Balance.toString()
                        .toLocaleLowerCase()
                        .includes(_this.state.searching.toLocaleLowerCase()) ||
                    generate_BillNo_Format(x.BillNo)
                        .toLocaleLowerCase()
                        .includes(_this.state.searching.toLocaleLowerCase()) ||
                    moment(x.AdjustmentDate)
                        .format("MM/DD/YYYY")
                        .includes(_this.state.searching.toLocaleLowerCase());
            });
            _this.setState({ totalCount: tempData.length, searchRows: Array.from(tempData) }, function () {
                _this.setState({
                    searchRows: tempData,
                }, function () {
                    _this.changeSorting(_this.state.sorting);
                });
            });
        };
        _this.getPaginatedResult = function (data) {
            return data.splice(_this.state.currentPage * _this.state.pageSize, _this.state.pageSize);
        };
        _this.setPaginatedResult = function () {
            var filtereddata = __spreadArray([], __read(_this.state.searchRows), false);
            var temp = filtereddata.length;
            var _tempData = _this.getPaginatedResult(filtereddata);
            _this.setState({
                paginatedData: _tempData,
                totalCount: temp,
            });
        };
        _this.changeSorting = function (sorting) {
            var _tempFilteredData = __spreadArray([], __read(_this.state.searchRows), false);
            var _a = sorting[0], columnName = _a.columnName, direction = _a.direction;
            var inverse = direction === "desc";
            _tempFilteredData = _tempFilteredData.sort(function (a, b) {
                var result = 0;
                if (a[columnName] < b[columnName])
                    result = -1;
                if (a[columnName] > b[columnName])
                    result = 1;
                if (!a[columnName] || !b[columnName]) {
                    var sort = !a[columnName] - !b[columnName];
                    return inverse ? -sort : sort;
                }
                return inverse ? -result : result;
            });
            _this.setState({
                sorting: sorting,
                searchRows: _tempFilteredData,
            }, _this.setPaginatedResult);
        };
        _this.companyChange = function (clientLedgerParams) {
            var _self = _this;
            _self.setState({ currentPage: 0 });
        };
        _this.defaultFormatter = function (row) {
            return _jsx("span", __assign({ title: row.value }, { children: row.value }));
        };
        _this.dateFormatter = function (row) {
            if (row.value) {
                return (_jsx("span", __assign({ title: moment(new Date(moment.utc(row.value).format())).format("MM/DD/YYYY") }, { children: moment(new Date(moment.utc(row.value).format())).format("MM/DD/YYYY") })));
            }
            return _jsx("span", {});
        };
        _this.adjustmentDateFormatter = function (row) {
            if (row.value) {
                return (_jsx("span", __assign({ title: moment(row.value).format("MM/DD/YYYY") }, { children: moment(row.value).format("MM/DD/YYYY") })));
            }
            return _jsx("span", {});
        };
        _this.downloadAsExcel = function () {
            var excelData = [];
            _this.state.searchRows.forEach(function (row) {
                excelData.push({
                    Date: moment(row.Date).format("MM/DD/YYYY"),
                    Description: row.Description,
                    Increase: row.Increase,
                    Decrease: row.Decrease,
                    Balance: row.Balance,
                    "Adjustment Date": row.AdjustmentDate
                        ? moment(row.AdjustmentDate).format("MM/DD/YYYY")
                        : "",
                });
            });
            excelUtilities.Download(excelData, "TransactionHistory", true);
        };
        _this.handleCompanyChange = function (selectedCompanyValue) {
            _this.setState({ selectedCompanyValue: selectedCompanyValue });
        };
        _this.columnSortLabel = function (props) {
            return (_jsx(TableHeaderRow.SortLabel, __assign({}, props, { getMessage: function () { return props.column.title || 'sort'; } })));
        };
        _this.cellFormatter = function (props) {
            return (_jsx(Table.Cell, __assign({}, props, { children: _jsx("span", __assign({ style: { fontSize: '13px' } }, { children: props.value })) })));
        };
        _this.state = {
            rows: [],
            paginatedData: [],
            searchRows: [],
            sorting: [{ columnName: "Date", direction: "desc" }],
            totalCount: 0,
            currentPage: 0,
            searching: "",
            pageSize: 20,
            currentBalance: 0,
            company: [],
            selectedCompanyValue: [],
            companyList: [],
        };
        return _this;
    }
    ExtensionClientLedger.prototype.componentDidMount = function () {
        var defaultCompanyId = this.props.location.state
            ? this.props.location.state.defaultCompanyId
            : 0;
        var selectedCompanyValue = [];
        var _self = this;
        getAdhocCompanies()
            .then(function (response) {
            var companyDetails = response.data.filter(function (company) { return defaultCompanyId == company.CompanyId; });
            if (companyDetails && companyDetails.length > 0) {
                var compDetail = companyDetails[0];
                selectedCompanyValue = {
                    value: compDetail.CompanyId,
                    label: compDetail.CompanyName,
                };
            }
            _self.setState({
                company: response.data,
                companyList: _self.prepareCompanyData(response.data),
                selectedCompanyValue: selectedCompanyValue,
            });
        })
            .catch(function (e) {
            console.log(e);
        });
        this.getClientLedgerData(new ClientLedgerParams(getYesterdaysDate(), new Date(), defaultCompanyId, this.getDeliveryMode()));
    };
    ExtensionClientLedger.prototype.downloadReceipt = function (row, receiptType) {
        location.href = "".concat(StringResource.RECEIPT_DOWNLOAD_URL, "/?receiptType=").concat(receiptType, "&transactionId=").concat(row.TransactionId, "&date=").concat(row.Date, "&companyId=").concat(this.state.selectedCompanyValue.value);
    };
    ExtensionClientLedger.prototype.downloadAllReceipt = function (row, receiptType) {
        location.href = "".concat(StringResource.All_RECEIPT_DOWNLOAD_URL, "/?receiptType=").concat(receiptType, "&transactionId=").concat(row.TransactionId, "&date=").concat(row.Date, "&billNo=").concat(row.BillNo, "&companyId=").concat(this.state.selectedCompanyValue.value);
    };
    ExtensionClientLedger.prototype.render = function () {
        return (_jsx(Container, __assign({ visibility: true, title: "Transaction History" }, { children: _jsxs("div", __assign({ className: "scroll-bar page-body-container", id: "micro-extension-transaction-history" }, { children: [_jsx(ExtensionClientLedgerFilter, { filter: this.getClientLedgerData, downloadAsExcel: this.downloadAsExcel, companyData: this.state.companyList, selectedCompanyValue: this.state.selectedCompanyValue, handleCompanyChange: this.handleCompanyChange }), _jsxs(Grid, __assign({ rows: this.state.paginatedData, columns: columns }, { children: [_jsx(SortingState, { sorting: this.state.sorting, onSortingChange: this.changeSorting }), _jsx(DataTypeProvider, { for: ["Date"], formatterComponent: this.dateFormatter }), _jsx(DataTypeProvider, { for: ["Description"], formatterComponent: this.defaultFormatter }), _jsx(DataTypeProvider, { for: ["Increase"], formatterComponent: this.defaultFormatter }), _jsx(DataTypeProvider, { for: ["Decrease"], formatterComponent: this.defaultFormatter }), _jsx(DataTypeProvider, { for: ["Balance"], formatterComponent: this.defaultFormatter }), _jsx(DataTypeProvider, { for: ["AdjustmentDate"], formatterComponent: this.adjustmentDateFormatter }), _jsx(SearchState, { value: this.state.searching, onValueChange: this.search }), _jsx(PagingState, { currentPage: this.state.currentPage, onCurrentPageChange: this.changeCurrentPage, pageSize: this.state.pageSize }), _jsx(CustomPaging, { totalCount: this.state.totalCount }), _jsx(Table, { cellComponent: this.cellFormatter }), _jsx(TableHeaderRow, { showSortingControls: true, sortLabelComponent: this.columnSortLabel }), _jsx(PagingPanel, {}), _jsx(Toolbar, {}), _jsx(SearchPanel, {})] }))] })) })));
    };
    return ExtensionClientLedger;
}(React.Component));
export default ExtensionClientLedger;
